import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import DataTable from "../../Components/DataTable/DataTable";
import { DatePicker, Message } from "@arco-design/web-react";
import { IconInfoCircle } from "@arco-design/web-react/icon";
import { ManageApis } from "../../AppServices/ManageApi";
import Loader from "../../Components/LoaderComponent/Loader";
import moment from "moment";
import {
  convertUtcToBrowserTimeZone,
  dataTableInitialLoader,
  getLocalStorage,
} from "../../Functions/Utils";
import { useStoreValues } from "../../Context/storeProvider";
import axios from "axios";
import dayjs from "dayjs";

function ServiceLogs() {
  const { user_Roll } = useStoreValues();
  const InitialFilterValue = {
    startDate: null,
    endDate: null,
    searchKey: "",
    serviceId: null,
    Type: "Aadhar Masking",
  };
  const [filterValues, setfilterValues] = useState(InitialFilterValue);
  const [accountList, setAccountList] = useState([{ key: 200, value: 200 }]);
  const [ServiceList, setServiceList] = useState([]);
  const [apiHitData, setApiHitData] = useState();
  const [DateRangeValue, setDateRangeValue] = useState([]);
  const [filterResponse, setFilterResponse] = useState({});
  const [TableData, setTableDta] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [tableLoader, setTableLoader] = useState(false);
  const [pageSize, setpageSize] = useState(10);
  const [currentPage, setcurrentPage] = useState(1);
  const [uiDServiceKey,setUidServiceKey] = useState([])
  const [Total, setTotal] = useState(0);

  const TableColumn = [
    {
      title: "Client Name",
      dataIndex: "client_name",
      headerCellStyle: {
        backgroundColor: "var(--mastercolor2)",
        color: "#fff",
      },
    },
    {
      title: "End Point",
      dataIndex: "endpoint",
      headerCellStyle: {
        backgroundColor: "var(--mastercolor2)",
        color: "#fff",
      },
    },
    {
      title: "Created Date",
      dataIndex: "time",
      headerCellStyle: {
        backgroundColor: "var(--mastercolor2)",
        color: "#fff",
      },
      render: (v, record) => {
        return <div>{new Date(record.time).toLocaleDateString()}</div>;
      },
    },
    {
      title: "IP Address",
      dataIndex: "ip_address",
      headerCellStyle: {
        backgroundColor: "var(--mastercolor2)",
        color: "#fff",
      },
    },
    {
      title: "Number of Execution",
      dataIndex: "number_of_execution",
      headerCellStyle: {
        backgroundColor: "var(--mastercolor2)",
        color: "#fff",
      },
    },
    {
      title: "Number of Pages",
      dataIndex: "number_of_pages",
      headerCellStyle: {
        backgroundColor: "var(--mastercolor2)",
        color: "#fff",
      },
    },

    {
      title: "Status Code",
      dataIndex: "status_code",
      headerCellStyle: {
        backgroundColor: "var(--mastercolor2)",
        color: "#fff",
      },
    },
  ];

  useEffect(() => {
    getServiceList().then((response) => {
      getSummaryList(
        filterValues.startDate,
        filterValues.endDate,
        currentPage,
        pageSize,
        filterValues.searchKey,
        response
      );
    });
  }, []);
  // getSummaryList()

  const getServiceList = async () => {
    try {
      setTableLoader(true);
      let response = await ManageApis("get", global.getServiceList);

      if (response.message === "Success") {
        if (response?.response_data?.length > 0) {
          let services = response?.response_data?.map((item) => ({
            key: item.id,
            value: item.name,
          }));
          let servicesUID = response?.response_data?.map((itm) => ({
            Uid: itm.id,
          }));
          setUidServiceKey(servicesUID);
          setServiceList(services);
          setfilterValues((pre) => ({ ...pre, serviceId: servicesUID[0].Uid }));
          return servicesUID[0].Uid;
        }
      } else {
        Message.error(response?.message);
      }
    } catch (error) {
      //console.log(error);
    } finally {
      setTableLoader(false);
    }
  };
  const handleDataRange = (event) => {
    if (event?.length) {
      setDateRangeValue(event);
      setfilterValues((pre) => ({
        ...pre,
        startDate: event[0],
        endDate: event[1],
      }));
    } else {
      setDateRangeValue([]);
      setfilterValues((pre) => ({ ...pre, startDate: "", endDate: "" }));
    }
  };

  const getSummaryList = async (
    startDate,
    endDate,
    pageNumber,
    pageSize,
    searchkey,
    serviceId
  ) => {
    try {
      setTableLoader(true);
      const request = {
        startDate: startDate || null,
        endDate: endDate || null,
        searchKey: searchkey || "",
        pageNumber: pageNumber || 1,
        pageSize: pageSize || 10,
        serviceId: `${serviceId}`,
      };
      let response = await ManageApis("post", global.getSummarylogs, request);

      if (response.message === "Success") {
        if (response?.response_data?.data?.length > 0) {
          setTableDta(response?.response_data?.data);
          setTotal(response?.response_data?.totalCount);
        } else {
          setTableDta([]);
          setTotal(0);
        }
      } else {
        Message.error(response?.message);
      }
    } catch (error) {
      //console.log(error);
    } finally {
      setTableLoader(false);
    }
  };
  const handleReset = () => {
    try {
      setDateRangeValue([]);
      getSummaryList(
        "",
        "",
        1,
        pageSize,
        "",
        uiDServiceKey[0]?.Uid
      );
      setfilterValues((prev)=>({...prev,serviceId:uiDServiceKey[0]?.Uid,searchKey: '',startDate: null,endDate: null,searchKey: "",}))
    //   getSummaryList()
    } catch (error) {
      //console.log(error);
    }
  };
  function onChangeTable(pagination) {
    // //console.log(pagination);
    const { current, pageSize } = pagination;
    setTableLoader(true);
    setApiHitData(dataTableInitialLoader(TableColumn));

    setTimeout(() => {
      setApiHitData(
        TableData.slice((current - 1) * pageSize, current * pageSize)
      );
      setcurrentPage(current);
      setpageSize(pageSize);
      setTableLoader(false);
    }, 500);

    getSummaryList(
      filterValues.startDate,
      filterValues.endDate,
      current,
      pageSize,
      filterValues.searchKey,
      filterValues.serviceId
    );
  }

  const handleDownload = async () => {
    try {
      const params = {
        searchKey: filterValues.searchKey,
        startDate: filterValues.startDate,
        endDate: filterValues.endDate,
        serviceId: filterValues.serviceId,
      };

      const response = await axios.post(
        global.uploadData + global.ExportSummary,
        params,
        {
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${getLocalStorage("access_token")}`,
          },
          responseType: "blob",
        }
      );
      if (response.status == 200) {
        const filename = `ExportSummaryLogs${Date.now()}.xlsx`;
        // Create a download link and trigger a click event to start the download
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(response.data);
        link.download = filename;
        link.click();
      } else {
        alert("Something Went Wrong");
      }
    } catch (error) {
      alert("Connectivity Issue. Please try again later");
    }
  };

  const handleSubmitFilter = () => {
    try {
      getSummaryList(
        filterValues.startDate,
        filterValues.endDate,
        1,
        pageSize,
        filterValues?.searchKey,
        filterValues.serviceId
      );
    } catch (error) {
      //console.log(error);
    }
  };

  return (
    <>
      {isLoading && <Loader />}

      <div className="">
        <div className="admin_Section overflow-auto scrollbar1">
          <div className="px-3">
            <div className="mb-3 ">
              <div className="d-flex justify-content-end ">
                <button
                  className="mt-2 ms-0 ms-md-2 mt-md-0 btn px_btn btn-master-line px-3 py-2 rounded fw_500 font_12 "
                  disabled={!TableData?.length}
                  onClick={handleDownload}
                >
                  Download
                </button>
              </div>
              <div className="row align-items-center ">
                <div className="col-12 col-lg-2 col-md-3 mb-3 mb-md-0">
                  <h3 className="font_18 fw_600 mb-0 text-black py-2">
                    Service Logs
                  </h3>
                </div>
                <div className="align-items-center col-12 col-xl-10">
                  <div className="align-items-center d-flex flex-column flex-md-row gap-2">
                    {user_Roll !== "Admin" && (
                      <div className="d-flex flex-column w-100">
                        <span className="font_14 fw_500 ws_nowrp d-none">
                          Client Name
                        </span>
                        <span className="font_14 fw_500 ws_nowrp">Account</span>
                        <select
                          className="form-control rounded font_14"
                          onChange={(e) =>
                            setfilterValues((pre) => ({
                              ...pre,
                              accountList: e.target.value,
                            }))
                          }
                          value={filterValues.accountList}
                        >
                          {accountList?.map((itm) => (
                            <option value={itm?.key}>{itm.value}</option>
                          ))}
                        </select>
                      </div>
                    )}
                    <div className="d-flex flex-column  w-100">
                      <span className="font_14 fw_500 ws_nowrp">
                        Service List
                      </span>

                      <select
                        className="form-control rounded font_14"
                        onChange={(e) => {
                            setfilterValues((pre) => ({
                              ...pre,
                              serviceId: e.target.value,
                            }));
                          }}
                        value={filterValues.serviceId}
                      >
                        {ServiceList?.map((itm) => (
                          <option value={itm?.key}>{itm.value}</option>
                        ))}
                      </select>
                    </div>
                    <div className="d-flex flex-column  w-100">
                      <span className="font_14 fw_500 ws_nowrp">Search</span>

                      <input
                        className="form-control"
                        placeholder="Search here.."
                        onChange={(e) =>
                          setfilterValues((pre) => ({
                            ...pre,
                            searchKey: e.target.value,
                          }))
                        }
                        value={filterValues.searchKey}
                      />
                    </div>
                    <div className="d-flex flex-column w-100">
                      <span className="font_14 fw_500 ws_nowrp">Date</span>
                      <div className="arco_rangepicker w-100 min_w_260x">
                        <DatePicker.RangePicker
                          allowClear
                          onClear={() => setDateRangeValue([])}
                          onChange={handleDataRange}
                          value={DateRangeValue}
                          style={{
                            width: "100%",
                            height: 40,
                            borderColor: "#eee",
                            backgroundColor: "transparent",
                          }}
                          disabledDate={(current) => current.isAfter(dayjs())}
                          prefix={<IconInfoCircle />}
                        />
                      </div>
                    </div>
                    <div className="d-flex flex-column w-100 flex-md-row mt-1 pt-3">
                      <button
                        className="btn px_btn btn-master px-4 py-2 rounded fw_500 font_12 w-100"
                        onClick={handleSubmitFilter}
                      >
                        Filter
                      </button>
                      <button
                        className="mt-2 ms-0 ms-md-2 mt-md-0 btn px_btn btn-master-line px-3 py-2 rounded fw_500 font_12 w-100"
                        onClick={handleReset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                  {/* <div className="flex-fill">
                                    </div> */}
                </div>
              </div>
            </div>
            <div className="row d-none">
              <div className="col-12 col-md-4 mb-3">
                <div className="align-items-center bd_master border-6 border-bottom box_width01 d-flex gap-2 justify-content-between p-3 rounded-3 shadow white_box">
                  <h5 className="mb-0 text-black fw_600 font_16">
                    Total API Hit Count
                  </h5>
                  <div className="min_h_50x min_w_50x align-items-center bd_master border border-7 d-flex font_14 font_600 justify-content-center mb-0 rounded-circle text-black sts_r1">
                    {filterResponse?.totalCount || 0}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-4 mb-3">
                <div className="align-items-center bd_master border-6 border-bottom box_width01 d-flex gap-2 justify-content-between p-3 rounded-3 shadow white_box">
                  <h5 className="mb-0 text-black fw_600 font_16">
                    Aadhar Card API Hit Count
                  </h5>
                  <div className=" min_h_50x min_w_50x align-items-center bd_master border border-7 d-flex font_14 font_600 justify-content-center mb-0 rounded-pill text-black sts_r1">
                    {filterResponse?.aadharcount || 0}
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-4 mb-3">
                <div className="align-items-center bd_master border-6 border-bottom box_width01 d-flex gap-2 justify-content-between p-3 rounded-3 shadow white_box">
                  <h5 className="mb-0 text-black fw_600 font_16">
                    Pan Card API Hit Count{" "}
                  </h5>
                  <div className="min_h_50x min_w_50x align-items-center bd_master border border-7 d-flex font_14 font_600 justify-content-center mb-0 rounded-pill text-black sts_r1">
                    {filterResponse?.pancount || 0}
                  </div>
                </div>
              </div>
            </div>
            <div className="overflow-auto  scrollbar1">
              <DataTable
                columnData={TableColumn}
                rowData={TableData}
                onChangeTable={onChangeTable}
                current={currentPage}
                pageSize={pageSize}
                total={Total}
                loading={tableLoader}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ServiceLogs;
